"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRouterModule = exports.AppBarModule = exports.LoginModule = void 0;

var _connectedReactRouter = require("connected-react-router");

var _loginReducer = _interopRequireDefault(require("./loginReducer"));

var _appBarTabs = _interopRequireDefault(require("./appBarTabs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginModule = {
  id: "loginReducer",
  reducerMap: {
    loginReducer: _loginReducer.default
  }
};
exports.LoginModule = LoginModule;
var AppBarModule = {
  id: "appBarTabs",
  reducerMap: {
    appBarTabs: _appBarTabs.default
  }
};
exports.AppBarModule = AppBarModule;

var createRouterModule = function createRouterModule(history) {
  return {
    id: "router",
    reducerMap: {
      router: (0, _connectedReactRouter.connectRouter)(history)
    }
  };
};

exports.createRouterModule = createRouterModule;